import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";

interface VisitLoggedBottomSheetProps {
  modalState: UseModalState;
}

export function VisitLoggedBottomSheet(props: VisitLoggedBottomSheetProps) {
  const { modalState } = props;
  const { case: caseData } = useInHomeVisitModalsDataContext();
  const { data: facility } = useFacilityProfile(
    { workplaceId: caseData?.attributes.workplaceId ?? "" },
    {
      enabled: isDefined(caseData?.attributes.workplaceId),
    }
  );

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" onClick={modalState.closeModal}>
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="shift-booked"
        title="Your visit has been logged"
        description={
          <Text variant="body1">
            After {facility?.name ?? "the agency"} has approved your visit, you&apos;ll be instantly
            paid
          </Text>
        }
      />
    </BottomSheet>
  );
}
